import React, { PropTypes } from 'react';
import { NitroIcon, NitroLogo } from 'nitro-components';
import styled from 'styled-components';
import { Link } from 'react-router';

import TopNavigation from './TopNavigation';
import GlobalSearchBarMobile from '../../../features/common/GlobalSearchBar/GlobalSearchMobile';
import Menu from '../Menu/Sidebar/Menu';
import Breakpoint from '../../../utils/breakpoints';
import Profile from '../Profile';

const Icon = styled(NitroIcon)`
  padding: 16px 20px;

  span: {
    display: inline-flex;
  }
`;

const HeaderLogo = styled(Link)`
  cursor: pointer;
  display: inline-flex;
  width: 170px;
  height: 100%;
  padding: 8px 0;
`;

const NavigationIcon = styled(Icon)`
  height: 20px;
  box-sizing: content-box;
`;

const NavigationGroup = styled.section`
  display: flex;
  flex-shrink: 0;
  align-items: center;
  color: rgba(255, 255, 255, 1);
`;

/**
 * This component is a common header for mobile and tablet devices to be displayed on pages that require navigation.
 */
class MobileNavigation extends React.Component {
  state = {
    open: false,
    showSearch: false
  };

  // Close the mobile sidebar if there was a change in the url
  componentDidUpdate(prevProps) {
    if (this.props.location.pathname !== prevProps.location.pathname) {
      // eslint-disable-next-line react/no-did-update-set-state
      this.closeSidebar();
    }
  }

  closeSidebar = () => this.setState({ open: false });

  render() {
    return (
      <Breakpoint name="mobileTablet">
        <TopNavigation hideWhenScrolled={this.props.hideWhenScrolled}>
          <NavigationGroup>
            <Icon
              name="menu"
              size={20}
              variant="white"
              action={() => this.setState({ open: true })}
            />
            <HeaderLogo to={this.props.homeRoute}>
              <NitroLogo />
            </HeaderLogo>
          </NavigationGroup>
          <NavigationGroup>
            <NavigationIcon
              name="search"
              size={20}
              variant="white"
              action={() => this.setState({ showSearch: true })}
            />
            <Profile location={location} avatarOnly />
          </NavigationGroup>
        </TopNavigation>

        <Menu
          {...this.props}
          open={this.state.open}
          onClose={this.closeSidebar}
        />

        {this.state.showSearch && (
          <GlobalSearchBarMobile
            isOpen={this.state.showSearch}
            onBack={() => this.setState({ showSearch: false })}
            close={() => this.setState({ showSearch: false })}
          />
        )}
      </Breakpoint>
    );
  }
}

MobileNavigation.propTypes = {
  // The react router current location
  location: PropTypes.shape({
    pathname: React.PropTypes.string.isRequired
  }).isRequired,

  // True if the navigation should move off screen when the user scrolls down
  // and on screen when the user scrolls up
  hideWhenScrolled: PropTypes.bool
};

MobileNavigation.defaultProps = {
  hideWhenScrolled: true
};

export default MobileNavigation;



// WEBPACK FOOTER //
// ./src/components/common/Navigation/MobileNavigation.js